import { Socket } from 'phoenix'

let sockets
let channels

export function resetSocketsAndChannels() {
  sockets = {}
  channels = {}
}

resetSocketsAndChannels()

function getCSRFToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.getAttribute('content') : '0'
}

function getConnectedSocket(socketRoute) {
  return new Promise((resolve, reject) => {
    if ('string' !== typeof socketRoute) {
      return reject(new Error('invalid socket route'))
    }

    let socket = sockets[socketRoute]

    if (socket) {
      if (socket.isConnected()) {
        return resolve(socket)
      } else {
        return reject(new Error('socket is not connected'))
      }
    }

    const params = { _csrf_token: getCSRFToken() }
    socket = new Socket(socketRoute, { params })
    sockets[socketRoute] = socket

    const onErrorRef = socket.onError((data) => {
      // We only want this callback to reject the Promise when the initial attempt
      // to connect the socket fails.
      const msgExtra = data ? `: ${data}` : ''
      reject(new Error(`error connecting to socket${msgExtra}`))
    })

    socket.onOpen(() => {
      // Once the socket is open, we want to unhook the onError callback, so it
      // doesn't attempt to reject this promise after we've already resolved it.
      socket.off([onErrorRef])
      resolve(socket)
    })

    // When successful, socket.connect() returns undefined
    socket.connect()
  })
}

export function getJoinedChannel(socketRoute, channelTopic, channelParams = {}) {
  return new Promise((resolve, reject) => {
    getConnectedSocket(socketRoute)
      .then((socket) => {
        const channelKey = [socketRoute, channelTopic]
        let channel = channels[channelKey]

        if (channel) {
          return resolve(channel)
        }

        channel = socket.channel(channelTopic, channelParams)
        channels[channelKey] = channel

        channel
          .join()
          .receive('ok', () => resolve(channel))
          .receive('error', () => reject(new Error('channel could not be joined')))
      })
      .catch(reject)
  })
}
